import axios from 'axios';
import { acquireAccessToken } from '../msal/_utilities';
import msalConfig from '../msal/config';

/**
 * Axios instance configured to call Microsoft Graph API
 */
const graphInstance = axios.create({
	baseURL: 'https://graph.microsoft.com/v1.0/',
});
graphInstance.interceptors.request.use(
	async config => {
		const token = await acquireAccessToken(msalConfig.requests.graph);

		config.headers.Authorization = `Bearer ${token}`;

		return config;
	},
	function (err) {
		return Promise.reject(err);
	}
);
export { graphInstance as GraphAxios };
